export class Employee {
  id: number;
  firstName: string;
  lastName: string;
  count: number;
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/shared/employee.ts